(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["azadi-sale-section"] && !Shopify.designMode) return;
  try {
    
(function () {
  "use strict";

  function pad(n) { return String(n).padStart(2, "0"); }

  document.querySelectorAll("[data-azaadi-countdown]").forEach(function (el) {
    var raw = el.getAttribute("data-target");
    var target = raw ? new Date(raw) : null;
    if (!target || isNaN(target.getTime())) { el.style.display = "none"; return; }

    var days = el.querySelector("[data-cd-days]");
    var hours = el.querySelector("[data-cd-hours]");
    var mins = el.querySelector("[data-cd-mins]");
    var secs = el.querySelector("[data-cd-secs]");

    function tick() {
      var diff = target.getTime() - Date.now();
      if (diff < 0) diff = 0;
      days.textContent = pad(Math.floor(diff / 86400000));
      hours.textContent = pad(Math.floor((diff % 86400000) / 3600000));
      mins.textContent = pad(Math.floor((diff % 3600000) / 60000));
      secs.textContent = pad(Math.floor((diff % 60000) / 1000));
    }
    tick();
    setInterval(tick, 1000);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
